import collarDetailsList from './collarDetails/list';
import costrDetailsList from './costDetails/list';
import rawData from './rawData/list';
import productionData from './productionData/list';
import prescriptionData from './prescriptionData/list';
import costConfirmation from './costConfirmation/list';
import outStock from './outStock/list';
import inStock from './inStock/list';
import materialsInStock from './materialsInStock/list';
import inAndOutStore from './inAndOutStore/list';
import materialsInAndOutStore from './materialsInAndOutStore/list';
import expenseDetail from './expenseDetail/list';
import settleSummary from './settleSummary/list';
import pdPeriod from './pdPeriod/list';
import productPrice from './productPrice/list';
export default {
  ...collarDetailsList,
  ...costrDetailsList,
  ...rawData,
  ...costConfirmation,
  ...productionData,
  ...prescriptionData,
  ...outStock,
  ...inStock,
  ...materialsInStock,
  ...inAndOutStore,
  ...materialsInAndOutStore,
  ...expenseDetail,
  ...settleSummary,
  ...pdPeriod,
  ...productPrice,
};
